import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.scss'],
})
export class SearchBoxComponent implements OnInit {
    private _searchTerm: string;
    searchElement: any;
    searchActive = false;

    @Input('searchableList') searchableList: Array<any>;
    @Input('searchDefaultText') searchDefaultText: string;
    @Input('dialogHeader') dialogHeader: string;
    @Input('searchableItemFieldName') searchableItemFieldName: string;
    @Output('searchedList') searchedList: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

    constructor() {}

    ngOnInit() {
        this.searchElement = document.getElementById('search-input');
        this.searchElement.style.display = 'none';
    }

    get searchTerm(): string {
        return this._searchTerm;
    }

    set searchTerm(value: string) {
        this._searchTerm = value;
        if (value != '') {
            this.searchedList.emit(this.filterSearchList(value));
        } else {
            this.searchedList.emit(this.searchableList);
        }
    }

    changeSearchText(searchInput) {
        const defaultTextLabel = document.getElementById('default-text-label');
        if (defaultTextLabel.style.display === 'none') {
            defaultTextLabel.style.display = 'block';
            this.searchElement.style.display = 'none';
            this.searchActive = false;
        } else {
            defaultTextLabel.style.display = 'none';
            this.searchElement.style.display = 'block';
            this.searchElement.focus();
            this.searchElement.style.outline = 'none';
            this.searchElement.attributes.getNamedItem('placeholder').value =
                this.searchDefaultText;
            this.searchActive = true;
        }
    }

    filterSearchList(searchString: string) {
        return this.searchableList.filter(
            (item) =>
                item[this.searchableItemFieldName]
                    .toLowerCase()
                    .indexOf(searchString.toLowerCase()) !== -1
        );
    }

    searchRows(event: string) {
        this.searchTerm = event;
    }
}
